import { FC } from 'react';

import { Typography } from '@mui/material';
import { css, styled } from '@mui/material/styles';
import { components, ValueContainerProps } from 'react-select';

import { LanguageOption } from './locale-picker.types';

export const LocalePickerValueContainer: FC<ValueContainerProps<LanguageOption, false>> = ({
  children,
  ...props
}) => (
  <components.ValueContainer {...props}>
    <StyledValue component="div" variant="body1" display="flex" p={2}>
      {children}
    </StyledValue>
  </components.ValueContainer>
);

const StyledValue = styled(Typography)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.palette.text.primary};
  `
) as typeof Typography; //Complications with the component prop - https://mui.com/material-ui/guides/typescript/#complications-with-the-component-prop
